import * as React from 'react';

import './ButtonRow.scss';

class ButtonRow extends React.Component {

    constructor(props: any) {
        super(props);
    }

    public render() {
        return(
            <div id="button-row-wrapper">{this.props.children}</div>
        );
    }
}

export default ButtonRow;



// WEBPACK FOOTER //
// ./src/Components/ButtonRow/ButtonRow.tsx